import axios from 'axios';
import { getBaseMainUrl } from './api_methods';
import { AUTH_ENDPOINTS } from './api_endpoints';

const axiosClient = axios.create({
  baseURL: getBaseMainUrl(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Keep base URL in sync with localStorage `environment` (prod/qa/future) on every request.
axiosClient.interceptors.request.use((config) => {
  config.baseURL = getBaseMainUrl();
  return config;
});

let isRefreshing = false;
let refreshPromise = null;

const shouldSkipRefresh = (url = '') => {
  return (
    url.includes(AUTH_ENDPOINTS.REFRESH_ADMIN) ||
    url.includes(AUTH_ENDPOINTS.REFRESH_RECRUITER) ||
    url.includes(AUTH_ENDPOINTS.LOGIN_ADMIN_EMAIL)
  );
};

const runRefreshFlow = async () => {
  try {
    await axiosClient.post(AUTH_ENDPOINTS.REFRESH_ADMIN, {});
  } catch (adminRefreshError) {
    await axiosClient.post(AUTH_ENDPOINTS.REFRESH_RECRUITER, {});
  }
};

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config || {};
    const status = error?.response?.status;
    const requestUrl = originalRequest?.url || '';

    if (
      (status !== 401 && status !== 400) ||
      originalRequest._retry ||
      shouldSkipRefresh(requestUrl)
    ) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    if (!isRefreshing) {
      isRefreshing = true;
      refreshPromise = runRefreshFlow().finally(() => {
        isRefreshing = false;
      });
    }

    try {
      await refreshPromise;
      return axiosClient(originalRequest);
    } catch (refreshError) {
      return Promise.reject(refreshError);
    }
  },
);

export default axiosClient;
